const STATE_KEY = 'rdaPublishedDocumentEditRequest';
const EVENT_NAME = 'rda:open-published-document-for-edit';

const clean = (value) => String(value || '').trim();

const normalizeModuleToken = (value) => clean(value).toLowerCase();

export const resolvePublishedDocumentEditTarget = (row) => {
  const payload = row?.event?.payload && typeof row.event.payload === 'object' ? row.event.payload : row?.payload && typeof row.payload === 'object' ? row.payload : {};
  const candidates = [
    row?.tab,
    row?.module,
    row?.engine,
    row?.type,
    row?.documentType,
    row?.contentData?.engine,
    row?.contentData?.documentType,
    row?.context?.module,
    payload?.module,
    payload?.engine,
    payload?.documentType,
  ].map(normalizeModuleToken).filter(Boolean);

  for (const candidate of candidates) {
    if (candidate.includes('contract')) return { tab: 'contracts', module: 'contracts' };
    if (candidate.includes('procur')) return { tab: 'procurations', module: 'procurations' };
  }

  return null;
};

export const buildPublishedDocumentEditRequest = (row) => {
  const target = resolvePublishedDocumentEditTarget(row);
  const payload = row?.event?.payload && typeof row.event.payload === 'object' ? row.event.payload : row?.payload && typeof row.payload === 'object' ? row.payload : {};
  const documentId = clean(row?.documentId || row?.id || payload?.documentId);
  const publicationSeriesId = clean(row?.publicationSeriesId || payload?.publicationSeriesId || documentId);
  if (!target || !documentId) return null;

  return {
    documentId,
    publicationSeriesId,
    tab: target.tab,
    module: target.module,
    title: clean(row?.title || row?.name || row?.fileName || payload?.title || payload?.fileName),
    requestedAt: Date.now(),
  };
};

export const queuePublishedDocumentEdit = (row) => {
  if (typeof window === 'undefined') return null;
  const request = buildPublishedDocumentEditRequest(row);
  if (!request) return null;

  try {
    const nextState = {
      ...((window.history && typeof window.history.state === 'object' && window.history.state) ? window.history.state : {}),
      [STATE_KEY]: request,
    };
    window.history.replaceState(nextState, document.title, window.location.href);
  } catch {
  }

  try {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: request }));
  } catch {
  }

  try {
    if (window.sessionStorage) {
      window.sessionStorage.setItem(STATE_KEY, JSON.stringify(request));
    }
  } catch {
  }

  return request;
};

export const readQueuedPublishedDocumentEdit = (expectedTab = '') => {
  if (typeof window === 'undefined') return null;
  const historyRequest = window.history?.state?.[STATE_KEY] || null;
  if (historyRequest && typeof historyRequest === 'object') {
    if (clean(expectedTab) && clean(historyRequest?.tab) !== clean(expectedTab)) return null;
    return historyRequest;
  }

  try {
    const raw = window.sessionStorage ? window.sessionStorage.getItem(STATE_KEY) : null;
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    if (clean(expectedTab) && clean(parsed?.tab) !== clean(expectedTab)) return null;
    return parsed;
  } catch {
    return null;
  }
};

export const clearQueuedPublishedDocumentEdit = (expectedTab = '') => {
  if (typeof window === 'undefined') return;
  try {
    const state = (window.history && typeof window.history.state === 'object' && window.history.state) ? window.history.state : {};
    const current = state?.[STATE_KEY];
    if (current && typeof current === 'object') {
      if (!clean(expectedTab) || clean(current?.tab) === clean(expectedTab)) {
        const nextState = { ...state };
        delete nextState[STATE_KEY];
        window.history.replaceState(nextState, document.title, window.location.href);
      }
    }
  } catch {
  }

  try {
    const raw = window.sessionStorage ? window.sessionStorage.getItem(STATE_KEY) : null;
    if (!raw) return;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return;
    if (clean(expectedTab) && clean(parsed?.tab) !== clean(expectedTab)) return;
    if (window.sessionStorage) window.sessionStorage.removeItem(STATE_KEY);
  } catch {
  }
};

export const publishedDocumentEditEventName = EVENT_NAME;
